import { ArrowsClockwise, House, Warning } from '@phosphor-icons/react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'

interface GlobalErrorOverlayProps {
  isVisible: boolean
  onReload?: () => void
  onGoHome?: () => void
}

export function GlobalErrorOverlay({
  isVisible,
  onReload,
  onGoHome,
}: GlobalErrorOverlayProps) {
  if (!isVisible) return null

  const handleReload = () => {
    if (onReload) {
      onReload()
      return
    }
    window.location.reload()
  }

  const handleGoHome = () => {
    if (onGoHome) {
      onGoHome()
      return
    }
    window.location.href = '/workspace'
  }

  return (
    <div
      className={cn(
        'fixed inset-0 z-9999 flex items-center justify-center',
        'bg-black/60 backdrop-blur-md',
        'animate-in fade-in-0 duration-300',
      )}
      aria-live="polite"
      aria-label="Erro inesperado na aplicação"
    >
      <div
        className={cn(
          'flex flex-col items-center justify-center gap-6',
          'rounded-2xl bg-card p-10 shadow-2xl',
          'border border-border/50',
          'min-w-[320px] max-w-[420px] mx-4',
          'animate-in zoom-in-95 fade-in-0 duration-300',
        )}
      >
        {/* Ícone animado com efeito de pulso (vermelho para erro de app) */}
        <div className="relative flex items-center justify-center">
          <div className="absolute inset-0 rounded-full bg-red-500/20 animate-ping animation-duration-2000" />
          <div className="absolute inset-0 rounded-full bg-red-500/15 animate-ping animation-duration-2000 animation-delay-500" />
          <div className="relative rounded-full bg-red-500/10 p-5 border-2 border-red-500/20">
            <Warning className="h-10 w-10 text-red-500" />
          </div>
        </div>

        {/* Texto principal */}
        <div className="flex flex-col items-center gap-3 text-center">
          <h3 className="text-xl font-semibold text-foreground">
            Ops! Algo deu errado na aplicação
          </h3>
          <p className="text-sm text-muted-foreground max-w-[320px] leading-relaxed">
            Detectamos um erro inesperado na interface. Você pode recarregar a
            página ou voltar para o início. Se o problema persistir, entre em
            contato com o suporte.
          </p>
        </div>

        {/* Ações */}
        <div className="flex flex-col sm:flex-row gap-2 mt-1 w-full">
          <Button
            variant="outline"
            className="flex-1"
            type="button"
            onClick={handleReload}
          >
            <ArrowsClockwise className="h-4 w-4 mr-2" />
            Recarregar página
          </Button>
          <Button
            variant="default"
            className="flex-1"
            type="button"
            onClick={handleGoHome}
          >
            <House className="h-4 w-4 mr-2" />
            Ir para início
          </Button>
        </div>
      </div>
    </div>
  )
}

